<template>
  <div class="token-what-does-cpex bg--color-01">
    <div class="container-wrapper bg--color-11">
      <div class="token-what-does-cpex__container">
        <div class="token-what-does-cpex__grid container-new">
          <div class="token-what-does-cpex__info-item">
            <span
              class="txt txt--36px txt--height-44px txt--44px--m txt--height-58px--m txt--color-04 txt--bold txt--center"
            >
              {{ $t('token.whatDoesCpex.title') }}
            </span>

            <span
              class="txt txt--16px txt--height-20px txt--22px--m txt--height-30px--m txt--color-04 txt--center"
            >
              {{ $t('token.whatDoesCpex.description') }}
            </span>
          </div>

          <div class="token-what-does-cpex__items">
            <div class="token-what-does-cpex__items-list">
              <div
                v-for="(item, index) in items"
                :key="index"
                class="token-what-does-cpex__items-item bg--color-01"
              >
                <img :src="item.image" :alt="item.text" loading="lazy">

                <span
                  class="txt txt--22px txt--height-30px txt--26px--m txt--height-34px--m txt--color-04 txt--bold"
                >
                  {{ item.text }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    items () {
      return [
        require('@/assets/img/token/what-does-cpex/campus.svg'),
        require('@/assets/img/token/what-does-cpex/levels.svg'),
        require('@/assets/img/token/what-does-cpex/fee-discounts.svg'),
        require('@/assets/img/token/what-does-cpex/benefits.svg'),
      ].map((item, index) => {
        return {
          image: item,
          text: this.$t(`token.whatDoesCpex.items.${index}`),
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.token-what-does-cpex {
  &__info-item {
    grid-area: info;
    display: flex;
    flex-direction: column;
    gap: toRem(18px);
  }

  &__items {
    grid-area: items;
    display: flex;
    flex-direction: column;
    gap: toRem(24px);
  }

  &__items-list {
    grid-area: items;
    display: grid;
    grid-template-columns: 1fr;
    gap: toRem(12px);

    @include bp(550px) {
      grid-template-columns: repeat(2, 1fr);
      gap: toRem(20px);
    }

    @include bp(m) {
      gap: toRem(24px);
    }

    @include bp(l) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas:
      'info'
      'items';
    gap: toRem(36px);

    @include bp(m) {
      gap: toRem(60px);
    }
  }

  &__items-item {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: toRem(100px) 1fr;
    align-items: center;
    justify-items: center;
    gap: toRem(24px);
    padding: toRem(24px);
    border-radius: toRem(20px);
    text-align: center;

    @include bp(m) {
      grid-template-columns: 1fr;
      grid-template-rows: toRem(100px) 1fr;
      gap: toRem(14px);
      border-radius: toRem(24px);

      img {
        max-width: 100%;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }
}
</style>
